// Favorites service to manage saved artwork
const FAVORITES_STORAGE_KEY = 'jmr_favorites';

// Get all favorite items
export const getFavorites = () => {
  try {
    const favoritesJson = localStorage.getItem(FAVORITES_STORAGE_KEY);
    return favoritesJson ? JSON.parse(favoritesJson) : [];
  } catch (error) {
    console.error('Error retrieving favorites:', error);
    return [];
  }
};

// Add an item to favorites
export const addToFavorites = (item) => {
  try {
    const currentFavorites = getFavorites();
    
    // Check if the item is already in favorites
    const exists = currentFavorites.some(fav => fav.id === item.id);
    
    if (!exists) {
      const updatedFavorites = [...currentFavorites, item];
      localStorage.setItem(FAVORITES_STORAGE_KEY, JSON.stringify(updatedFavorites));
      return true;
    }
    
    return false; // Item was already in favorites
  } catch (error) {
    console.error('Error adding to favorites:', error);
    return false;
  }
};

// Remove an item from favorites
export const removeFromFavorites = (itemId) => {
  try {
    const currentFavorites = getFavorites();
    const updatedFavorites = currentFavorites.filter(fav => fav.id !== itemId);
    
    localStorage.setItem(FAVORITES_STORAGE_KEY, JSON.stringify(updatedFavorites));
    return true;
  } catch (error) {
    console.error('Error removing from favorites:', error);
    return false;
  }
};

// Check if an item is in favorites
export const isInFavorites = (itemId) => {
  try {
    const currentFavorites = getFavorites();
    return currentFavorites.some(fav => fav.id === itemId);
  } catch (error) {
    console.error('Error checking favorites:', error);
    return false;
  }
};

// Clear all favorites
export const clearFavorites = () => {
  try {
    localStorage.removeItem(FAVORITES_STORAGE_KEY);
    return true;
  } catch (error) {
    console.error('Error clearing favorites:', error);
    return false;
  }
};

export default {
  getFavorites,
  addToFavorites,
  removeFromFavorites,
  isInFavorites,
  clearFavorites
};